import './ArrivalSection.scss'

import { HDSIcon } from '@here/hds-react-components'
import { RouteWaypoint } from 'data/model/routePlanner'
import { format } from 'date-fns'
import React, { CSSProperties } from 'react'
import { roundToPrecision } from 'utils/math'

export interface ArrivalSectionProps {
  routeWaypoint: RouteWaypoint
  time: Date
  address?: string
}

export default function ArrivalSection({
  address,
  time,
  routeWaypoint,
}: ArrivalSectionProps): JSX.Element {
  const formattedTime = format(time, 'HH:mm')
  const title =
    routeWaypoint.place !== undefined
      ? routeWaypoint.place
      : address !== undefined && address !== ''
      ? address
      : `${roundToPrecision(routeWaypoint.lat, 5)}, ${roundToPrecision(routeWaypoint.lng, 5)}`

  return (
    <div className="ArrivalSection">
      <HDSIcon
        name="map-marker"
        category="map-view"
        size="32px"
        style={{ '--hds-icon-color': 'var(--hds-poi-default-home)' } as CSSProperties}
      />
      <div className="ArrivalSection__headline">
        <div className="ArrivalSection__header">
          <div className="ArrivalSection__title">{title}</div>
          <div className="ArrivalSection__time">{formattedTime}</div>
        </div>
        {address !== undefined && <div className="ArrivalSection__subtitle">{address}</div>}
      </div>
    </div>
  )
}
